import gql from 'graphql-tag'
import fragment from './fragment'

export default gql`
mutation createCashBookSettings($required: CashBookSettingsReqInput!, $fields: CashBookSettingsInput) {
	cashAssist {
		createMutation: createCashBookSettings(required: $required, fields: $fields) {
			id
			...CashBookSettingsMain
		}
	}
}
${fragment}`
